export default __webpack_public_path__ + "static/media/PCP1.21996931.png";